import { render } from "./FrontLayout.vue?vue&type=template&id=875504e8"
import script from "./FrontLayout.vue?vue&type=script&lang=js"
export * from "./FrontLayout.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/cargo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__